import { Route, Routes } from "react-router-dom";

import EmailBuilder from "containers/admin/clients/touchpoint/components/email-builder/email-builder";
import LPBuilder from "containers/admin/clients/touchpoint/components/lp-builder/lp-builder";
import BuilderProvider from "containers/admin/clients/touchpoint/components/builder/builder-provider/builder-provider";

export const BuilderRoutes = () => {
  return (
    <BuilderProvider>
      <Routes>
        <Route path="email-builder/*" element={<EmailBuilder previewMode={false} />} />
        <Route path="email-preview/*" element={<EmailBuilder previewMode={true} />} />
        <Route path="landing-page-builder/*" element={<LPBuilder previewMode={false} />} />
        <Route path="landing-page-preview/*" element={<LPBuilder previewMode={true} />} />
      </Routes>
    </BuilderProvider>
  );
};
